import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { BackChevron } from '../../BackChevron/BackChevron';

function MagazineSearchHeader() {
  const t = useTranslations('magazine.search_results');

  return (
    <div className="flex items-center gap-4" data-testid="magazine-search-header">
      <BackChevron fallbackUrl={ROUTES.MAGAZINE.HOME} />
      <h1 className="heading-5 text-foreground">{t('title')}</h1>
    </div>
  );
}

export { MagazineSearchHeader };
